import styled from 'styled-components'
import { border } from '../..'
import colors from '../../tokens/colors'
import fontFamily from '../../tokens/fonts'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const PinWrapper = styled.section`
  display: grid;
  grid-gap: ${layout.margin.spacingQuarck};
  font-family: ${fontFamily.inter};

  > label {
    font-weight: ${typography.fontWeight.fontWeightSemiBold};
  }
`

export const PinListContainer = styled.article.attrs((props) =>
  composeTheme(props),
)`
  display: flex;
  gap: ${layout.margin.spacingNano};

  input {
    border: ${border.width.widthThin} solid ${colors.neutralColorLowLight};
    width: ${layout.margin.spacingMd};
    height: ${layout.margin.spacingMd};
    margin: ${layout.margin.spacingNone};
    font-size: ${typography.fontSize.fontSizeXxs};
    line-height: ${typography.fontSize.fontSizeSm};
    border-radius: ${border.radius.radiusSm};
    text-align: center;
    outline-color: ${(props) => props.theme.brandColors.primaryPure};
    outline-width: ${border.width.widthThin};
  }
`
PinListContainer.defaultProps = defaultTheme
